import { IRecruiterDashboardMetrics } from '../../../../../hooks/useRecruiterDashboardMetrics';
import {
  METRIC_HIGHER_IS_BETTER,
  RETENTION_BREAKPOINTS,
} from '../../../constants';
import { IDateBounds, IModalLabels, IRetentionDetailsData } from '../../types';
import { getThresholdStatus } from '../getThresholdStatus';

export function buildRetentionModalData(
  metrics: IRecruiterDashboardMetrics | null,
  dateBounds: IDateBounds,
  labels: IModalLabels
): IRetentionDetailsData | null {
  if (!metrics) return null;

  const status = getThresholdStatus(
    metrics.retentionScore,
    RETENTION_BREAKPOINTS,
    {
      low: labels.statusNeedsAttention,
      mid: labels.statusOk,
      high: labels.statusExcellent,
    },
    METRIC_HIGHER_IS_BETTER.retention
  );

  return {
    periodLabel: labels.currentPeriod,
    periodStart: dateBounds.start,
    periodEnd: dateBounds.end,
    retentionScore: metrics.retentionScore,
    repeatDonorCount: metrics.repeatDonorCount,
    activeDonorCount: metrics.activeDonorCount,
    statusLabel: status.label,
    statusColor: status.color,
    breakpoints: RETENTION_BREAKPOINTS,
  };
}
